import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useTeacherUpdate = () => {
  const setTeacher = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v2/teacher/${payload.id}/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(setTeacher);
};

export default useTeacherUpdate;
